<template>
  <Component
    :is="layout"
    :record="record"
  >
    <template #sideCard>
      <slot name="sideCard" />
    </template>
    <template #header>
      <HeaderPart
        :record="record"
        class="card"
      >
        <h2
          v-if="record.titleAlternative"
          class="publication__alternative-title h4"
        >
          {{ record.titleAlternative.trim() }}
        </h2>
      </HeaderPart>
    </template>
    <template #keyInformation>
      <users-part
        v-model="record.creators"
        field-name="authors"
      />
      <users-part
        v-model="record.advisors"
        field-name="advisors"
      />
      <string-part
        field-name="dateIssued"
        :model-value="generateDateString(record.dateIssued)"
      />
      <text-part
        :model-value="record.description"
        field-name="abstract"
      />
    </template>
    <template #publicationDetails>
      <InstitutionUsersPart
        :users="record.creators"
        :section-title="$t('record.authors.institution', {communityName: configuration.institutionShortName })"
      />
      <InstitutionUsersPart
        :users="record.advisors"
        :section-title="$t('record.advisors.institution')"
      />
      <string-part
        :model-value="record.tid"
        field-name="tid"
      />
      <string-part
        field-name="doi"
        :model-value="record.doi"
      />
      <string-part
        :model-value="record.degreeName"
        field-name="degreeName"
      />
      <enum-part
        :model-value="record.subjectFos"
        field-name="subjectFos"
      />
      <SubjectPart :subject="record.subject" />
      <enum-part
        :model-value="record.language"
        field-name="languageIso"
      />
      <string-part
        :model-value="record.identifierUri"
        field-name="identifierUri"
      />
      <RightsPart
        :type="record.rights"
        :date-available="record.dateAvailable"
        :embargofct="record.embargofct"
      />
      <string-part
        :model-value="record.institutionName"
        field-name="institutionName"
      />
      <enum-part
        :model-value="record.licenseCondition"
        field-name="license"
      />
      <funding-references-part :funding-references="record.fundingReferences" />
    </template>
  </Component>
</template>

<script>
import SingleRecordLayout from '#src/layouts/SingleRecordLayout.vue'
import PreviewRecordLayout from '#src/layouts/PreviewRecordLayout.vue'
import HeaderPart from '#src/components/records/views/parts/HeaderPart.vue'
import UsersPart from '#src/components/records/views/parts/UsersPart.vue'
import InstitutionUsersPart from '#src/components/records/views/parts/InstitutionUsersPart.vue'
import RightsPart from '#src/components/records/views/parts/RightsPart.vue'
import SubjectPart from '#src/components/records/views/parts/SubjectPart.vue'
import StringPart from '#src/components/records/views/parts/StringPart.vue'
import TextPart from '#src/components/records/views/parts/TextPart.vue'
import EnumPart from '#src/components/records/views/parts/EnumPart.vue'
import FundingReferencesPart from '#src/components/records/views/parts/FundingReferencesPart.vue'

import DateHelpers from '#src/mixins/DateHelpers'
import { mapState } from 'vuex'

export default {
  name: 'MasterThesis',
  components: {
    SingleRecordLayout,
    PreviewRecordLayout,
    HeaderPart,
    UsersPart,
    InstitutionUsersPart,
    RightsPart,
    SubjectPart,
    StringPart,
    TextPart,
    EnumPart,
    FundingReferencesPart
  },
  mixins: [DateHelpers],
  props: {
    record: {
      required: true,
      type: Object
    },
    layout: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({ configuration: state => state.configuration })
  }
}
</script>
